import { handleActions } from '@housinganywhere/safe-redux';
import { FavoriteListing } from 'ha/services/apiV2/types/FavoriteListing';

import {
  Actions as FetchActions,
  ActionTypes as FetchActionTypes,
} from '../actions/getFavoriteListings';
import {
  Actions as AddActions,
  ActionTypes as AddActionTypes,
} from '../actions/addFavoriteListing';
import {
  Actions as RemoveActions,
  ActionTypes as RemoveActionTypes,
} from '../actions/removeFavoriteListing';

interface EntityStore {
  [key: string]: FavoriteListing;
}

export interface FavoriteListingState {
  listings: EntityStore;
  listingIds: number[];
  loadingListingIds: number[];
  pendingListingIds: number[];
  error: boolean;
}

export const initialState: FavoriteListingState = {
  // Listing id as key, listing as value
  listings: {},
  // List of listing ids that are favorites
  listingIds: [],
  // List of listing ids performing add/remove actions
  loadingListingIds: [],
  // List of pending listing ids while user passing authentication
  pendingListingIds: [],
  error: false,
};

type ActionTypes = FetchActionTypes | AddActionTypes | RemoveActionTypes;
type Actions = FetchActions | AddActions | RemoveActions;

const reducer = handleActions<FavoriteListingState, ActionTypes, Actions>(
  {
    [FetchActionTypes.START]: state => ({
      ...state,
      error: false,
    }),
    [FetchActionTypes.DONE]: (state, { payload: favorites }) => ({
      ...state,
      listingIds: favorites.map(
        (favorite: FavoriteListing) => favorite.listingId,
      ),
      listings: favorites.reduce(
        (entityStore: EntityStore, favorite: FavoriteListing) => ({
          ...entityStore,
          [favorite.listingId]: favorite,
        }),
        state.listings,
      ),
    }),
    [FetchActionTypes.FAIL]: state => ({
      ...state,
      error: true,
    }),

    [AddActionTypes.ADD_TO_PENDING_LIST]: (state, { payload: listingId }) => ({
      ...state,
      pendingListingIds: state.pendingListingIds.concat(listingId),
    }),
    [AddActionTypes.START]: (state, { payload: listingId }) => ({
      ...state,
      loadingListingIds: state.loadingListingIds.concat(listingId),
    }),
    [AddActionTypes.DONE]: (state, { payload: listingId }) => ({
      ...state,
      listingIds: state.listingIds.concat(listingId),
      loadingListingIds: state.loadingListingIds.filter(id => id !== listingId),
      pendingListingIds: state.pendingListingIds.filter(id => id !== listingId),
    }),
    [AddActionTypes.FAIL]: (state, { payload: listingId }) => ({
      ...state,
      loadingListingIds: state.loadingListingIds.filter(id => id !== listingId),
      pendingListingIds: state.pendingListingIds.filter(id => id !== listingId),
    }),

    [RemoveActionTypes.START]: (state, { payload: listingId }) => ({
      ...state,
      loadingListingIds: state.loadingListingIds.concat(listingId),
    }),
    [RemoveActionTypes.DONE]: (state, { payload: listingId }) => ({
      ...state,
      listingIds: state.listingIds.filter(id => id !== listingId),
      loadingListingIds: state.loadingListingIds.filter(id => id !== listingId),
    }),
    [RemoveActionTypes.FAIL]: (state, { payload: listingId }) => ({
      ...state,
      loadingListingIds: state.loadingListingIds.filter(id => id !== listingId),
    }),
  },
  initialState,
);

export default reducer;
